import { useTranslation } from 'react-i18next'
import PremiumLoader from './PremiumLoader'

interface FullPageLoaderProps {
  message?: string
}

/**
 * Full-page loader with themed background.
 * Used for Suspense fallback during page transitions.
 *
 * When no `message` is passed the component falls back to the translated
 * `common.loading` key so both FR and EN callers show the right copy
 * without the caller having to pass it every time.
 */
export default function FullPageLoader({ message }: FullPageLoaderProps) {
  const { t } = useTranslation('common')
  const resolved = message ?? t('actions.loading', { defaultValue: 'Loading...' })
  return (
    <div className="min-h-screen w-full bg-riseup-black light:bg-light-bg flex items-center justify-center transition-colors duration-300">
      <PremiumLoader message={resolved} />
    </div>
  )
}
